const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
/**
 * Builds a local-midnight `Date`. `new Date(y, m, d)` cannot be used: it maps
 * years 0-99 into the 1900s, and a stored date can be `0026-09-21`.
 */ export function localDate(year, monthIndex, day) {
    const date = new Date(0);
    date.setFullYear(year, monthIndex, day);
    date.setHours(0, 0, 0, 0);
    return date;
}
/**
 * Parses a `YYYY-MM-DD` date into a local-midnight `Date`.
 *
 * Returns `undefined` for anything else, including a date that does not exist
 * — the caller decides what an unparseable value means.
 */ export function parseIsoDate(value) {
    const match = ISO_DATE_PATTERN.exec(value);
    if (!match) return undefined;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = localDate(year, month - 1, day);
    const rolledOver = date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day;
    return rolledOver ? undefined : date;
}
/**
 * Formats a `Date` as the `YYYY-MM-DD` string for its local calendar day.
 * Local getters only — `toISOString` would shift the day east or west of UTC.
 */ export function formatIsoDate(date) {
    const year = String(date.getFullYear()).padStart(4, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

//# sourceMappingURL=date-string.js.map